export default __webpack_public_path__ + "static/media/ymvitlogo.e0834a61.png";